import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Avatar from 'material-ui/Avatar';
import Grid from 'material-ui/Grid';
import Paper from 'material-ui/Paper';
import colors from '../assets/colors.js';
import iconLinkedIn from '../assets/iconLinkedIn.png';
import iconResume from '../assets/iconResume.png';

const styles = {
  avatarContainer: {
    minWidth: 40,
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
  },
  avatar: {
    backgroundColor: colors.green,
    color: '#fff',
    minWidth: 40,
    margin: '8px 0 8px 8px',
  },
  iconLinkedIn: {
    background: 'url(' + iconLinkedIn + ') center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '24px',
    display: 'inline-block',
    height: '24px',
    margin: '0 0 -5px 8px',
    opacity: '0.15',
    width: '22px',
  },
  iconResume: {
    background: 'url(' + iconResume + ') center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '24px',
    display: 'inline-block',
    height: '24px',
    margin: '0 0 -5px 2px',
    opacity: '0.15',
    width: '20px',
  },
  name: {
    color: '#00A68C',
    fontWeight: '600',
    paddingTop: 3,
    whiteSpace: 'nowrap',
  },
  paperContainer: {
    height: '100%',
    display: 'flex',
  },
  paper: {
    backgroundColor: '#fff', 
    boxSizing: 'border-box',
    margin: 'auto',   
    padding: 10,
    textAlign: 'left',
    height: '100%',
  },
  role: {
    lineHeight: '22px',
    marginBottom: '8px'
  },
  textContainer: {
    padding: '0 10px 0 13px',
    alignSelf: 'center',
  }
};

class Leader extends React.Component {

  render() {
    const { classes, item } = this.props;

    return (
  		<Grid item xs={12} md={6} lg={4}>
        <Paper className={classes.paper}>
          <div className={classes.paperContainer}>
            <div className={classes.avatarContainer}>
              <Avatar className={classes.avatar}>{item.name.charAt(0)}</Avatar>
            </div>
            <div className={classes.textContainer}>
              <div className={classes.name}>
                {item.name}
                { item.linkedIn !== '' &&
                  <a href={'https://www.linkedin.com/in/'+ item.linkedIn} target='_blank'><i className={classes.iconLinkedIn}></i></a>
                }
                { item.resume !== '' &&
                  <a href={require(`../assets/${item.resume}`)} target="_blank"><i className={classes.iconResume}></i></a>
                }
              </div>
              <div className={classes.role}>{item.role}</div>
            </div>
          </div>
        </Paper>
      </Grid>
    );
  }
}

Leader.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Leader);


// WEBPACK FOOTER //
// ./src/components/Leader.js